<template>
  <div class="filterResultsItems">
    <button
      class="filterResultsItem"
      v-for="tag in tags"
      :key="tag.id"
      v-on:click="clearTag(tag)"
    >
      {{ tag.title }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    tags: {
      required: true,
      default: () => []
    }
  },
  setup(props, context) {
    const clearTag = tag => {
      context.emit("clearTag", tag);
    };
    return {
      clearTag
    };
  }
});
</script>
